import { combineReducers } from 'redux';
import authReducer from 'src/reducers/authReducer';

const rootReducer = combineReducers({
    auth: authReducer
});

export default rootReducer;
